import { GridColumnProps } from "@progress/kendo-react-grid";
import { CLASSNAME, COLOR } from "utils/constant";
import { GrideDateFormatter } from "ui/Date";
import { FC } from "react";
//import styles from "styles.module.css";
import i18n from "../../../../i18n";
import DotCell from "ui/grid/DotCell";
import CellPopover from "ui/grid/DescriptionCell";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";

let t = i18n.t;

const handleDotStatus = (status: number, signStatus: number) => {
	if (status === 1) return COLOR.StatusRed;
	if (status === 2) return COLOR.YellowLight;
	if (status === 3) return COLOR.StatusRed;
	if (status === 4 && signStatus === 0) return COLOR.Orange;
	return COLOR.StatusGreen;
};

export const SalesNoteGridColumnItem = () => {
	const gridItems: GridColumnProps[] = [
		{
			field: "",
			title: "",
			width: "30px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<DotCell
						value={props.dataItem.source}
						color={handleDotStatus(
							props.dataItem.noteStatusId,
							props.dataItem.signStatus
						)}
					/>
				),
			},
		},

		{
			field: "displayNoteNumber",
			title: t("Note"),
			width: "130px",
			headerClassName: "no-border",
		},

		{
			field: "vesselRegistrationId",
			title: t("VesselRegistrationId"),
			width: "110px",
		},
		{
			field: "vesselName",
			title: t("VesselName"),
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "buyerName",
			title: t("BuyerName"),
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "species",
			title: t("Species"),
			headerClassName: "no-border",
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "fishingGear",
			title: t("FishingGear"),
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "landingTime",
			title: t("DeliveryDateShort"),
			width: "120px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.landingTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "catchField",
			title: t("CatchArea"),
			width: "100px",
			headerClassName: "no-border",
		},
		{
			field: "catchAreaZone",
			title: t("Zone"),
			width: "60px",
			headerClassName: "no-border",
		},
		{
			field: "netLiveWeightKg",
			title: t("TotalWeight"),
			width: "120px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kg"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},
		},
		{
			field: "amount",
			title: t("TotalValue"),
			width: "120px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kr"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},
		},
	];
	return gridItems;
};

export const SalesNoteFrontGridColumnItem = () => {
	const gridItems: GridColumnProps[] = [
		{
			field: "",
			title: "",
			width: "30px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<DotCell
						value={props.dataItem.source}
						color={handleDotStatus(
							props.dataItem.noteStatusId,
							props.dataItem.signStatus
						)}
					/>
				),
			},
		},

		{
			field: "",
			title: "",
			width: "30px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<DotCell
						value={props.dataItem.source}
						color={handleDotStatus(
							props.dataItem.noteStatusId,
							props.dataItem.signStatus
						)}
					/>
				),
			},
		},

		{
			field: "noteNumber",
			title: t("Note"),
			width: "130px",
			headerClassName: "no-border",
		},

		{
			field: "vesselRegistrationId",
			title: t("VesselRegistrationId"),
			width: "110px",
		},
		{
			field: "vesselName",
			title: t("VesselName"),
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "buyerName",
			title: t("BuyerName"),
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "species",
			title: t("Species"),
			headerClassName: "no-border",
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "fishingGear",
			title: t("FishingGear"),
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "landingTime",
			title: t("DeliveryDateShort"),
			width: "120px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.landingTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "catchField",
			title: t("CatchArea"),
			width: "100px",
			headerClassName: "no-border",
		},
		{
			field: "catchAreaZone",
			title: t("Zone"),
			width: "60px",
			headerClassName: "no-border",
		},
		{
			field: "netLiveWeightKg",
			title: t("TotalWeight"),
			width: "120px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kg"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},
		},
		{
			field: "amount",
			title: t("TotalValue"),
			width: "120px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kr"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},
		},
	];
	return gridItems;
};

export const SalesNoteDetailGridItems: GridColumnProps[] = [
	{
		//this will not be render
		field: "lineNumber",
		title: "Linje",
	},
	{
		field: "lineNumber",
		title: t("Line"),
		width: "120px",
		cells: {
			data: (props) => (
				<td style={{ paddingLeft: "10px" }}>#{props.dataItem.lineNumber}</td>
			),
		},
	},

	{ field: "product", title: t("Product") },
	{
		field: "numberOfPieces",
		title: t("Pieces"),
		width: "120px",
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
		cells: {
			data: (props) => <NumericalCell {...props} formatDecimal={0} unit={""} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},
	},
	{
		field: "registeredLiveWeightKg",
		title: t("RegisteredWeight"),
		width: "130px",
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
		cells: {
			data: (props) => <NumericalCell {...props} unit={"kg"} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},
	},
	{
		field: "netLiveWeightKg",
		title: t("Weight"),
		width: "130px",
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
		cells: {
			data: (props) => <NumericalCell {...props} unit={"kg"} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},
	},
	{
		field: "price",
		title: t("Price"),
		width: "120px",
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
		cells: {
			data: (props) => <NumericalCell {...props} unit={"kr"} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},
	},
	{
		field: "amount",
		title: t("Value"),
		width: "140px",
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
		cells: {
			data: (props) => <NumericalCell {...props} unit={"kr"} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},
	},
	{
		width: "40px",
		className: `${CLASSNAME.TableNumeric} no-border`,
	},
];
